<template>
  <b-sidebar
    v-model="localValue"
    :id="id"
    :title="title"
    :right="right"
    :backdrop="backdrop"
    bg-variant="white"
    shadow
    :width="computedWidth"
    :no-close-on-backdrop="noCloseOnBackdrop"
    :no-close-on-esc="noCloseOnEsc"
  >
    <div style="background: #f3f6f7" class="h-100 p-4 overflow-auto">
      <slot />
    </div>
  </b-sidebar>
</template>

<script>
export default {
  name: 'CustomSidebar',
  model: {
    prop: 'value',
    event: 'input',
  },

  props: {
    value: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: 'base-sidebar',
    },
    title: {
      type: String,
      default: '',
    },
    right: {
      type: Boolean,
      default: true,
    },
    backdrop: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    noCloseOnBackdrop: {
      type: Boolean,
      default: false
    },
    noCloseOnEsc: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },

    computedWidth() {
      // Konversi preset ukuran ke lebar spesifik
      switch (this.size) {
        case 'sm':
          return '360px'
        case 'md':
          return '540px'
        case 'lg':
          return '720px'
        case 'xl':
          return '840px'
        default:
          return this.size // misalnya "800px"
      }
    },
  },
}
</script>
